import http from "./http";

// 🔹 GET TEAM LIST
export const getTeams = async () => {
  const res = await http.get("add-team");
  return res.data;
};

// 🔹 ADD TEAM
export const addTeam = async (formData) => {
  const res = await http.post("add-team", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

// 🔹 UPDATE TEAM
export const updateTeam = async (formData) => {
  const res = await http.post("add-team", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

// 🔹 DELETE TEAM
export const deleteTeam = async (id) => {
  const res = await http.delete("add-team", {
    data: { id },
  });
  return res.data;
};
